import Joi from '@hapi/joi';

const schema = Joi.object({
    // apiKey: Joi.string().alphanum(),
    // momaKey: Joi.string().alphanum(),

    map: Joi.object({
        center: [
            Joi.string(),
            Joi.array().items(Joi.string(), Joi.number()).length(2),
            Joi.object({
                lat: Joi.number(),
                lng: Joi.number(),
            }).allow(null),
        ],

        bounds: Joi.object().allow(null),
        layer: Joi.string().allow(null),

        internalStartDate: Joi.date().allow(null),
        internalEndDate: Joi.date().allow(null),
    }),

    panorama: Joi.object({
        panorama: Joi.object(),

        isLoading: Joi.boolean(),

        splitpanesSize: Joi.number().min(0).max(100),

        containerHeight: Joi.number().min(0),

        rawReverseGeocode: Joi.object().allow(null),

        orientation: Joi.object({
            yaw: Joi.number().allow(null),
            pitch: Joi.number().allow(null),
            fov: Joi.number().allow(null),
        }).allow(null),

        informationVisible: Joi.boolean(),

        gamma: Joi.number().min(-1).max(1),
    }),

    search: Joi.object({
        query: Joi.string().allow(''),

        pending: Joi.boolean(),

        summary: Joi.object(),

        rawResults: Joi.array(),

        selection: Joi.object().allow(null),

        miniature: Joi.string().allow(null),

        panelHidden: Joi.boolean(),

        isLoadingMiniature: Joi.boolean(),

        hasMiniatureError: Joi.boolean(),
    }),
});

export default Joi.object({
    vuex: Joi.string().custom((value) => {
        try {
            Joi.assert(JSON.parse(value), schema);
        } catch (e) {
            throw e;
        }
    }),

    // vuex-persistence test value
    '@@': Joi.number().equal(1).optional(),
});
